var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.test6}},[_vm._v("CLICK HERE")])])}
var staticRenderFns = []

export { render, staticRenderFns }